import React, { useState, createContext, useContext } from "react";

// Create Context Object
const LayersContext = createContext();

// Create a provider for components to consume and subscribe to changes
const LayersProvider = (props) => {
	const [layers, setLayers] = useState({
			laterals: true,
			sewerAlignment: true,
			proposedEasement: true,
			oepaBoundary: true,
	});

	return <LayersContext.Provider value={[layers, setLayers]}>{props.children}</LayersContext.Provider>;
};

const useLayers = () => {
	const context = useContext(LayersContext);
	if (context === undefined) {
		throw new Error('useSettings must be used within a LayersProvider');
	}
	return context;
}

export { LayersProvider, LayersContext, useLayers }